<div class="layout-sidebar" (click)="onMenuClick($event)">
	<a [routerLink]="['/cc/dashboard']" class="logo">
		<img
			id="app-logo"
			class="logo-image"
			src="https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/Focus-With-Cloud-New-Trans.png"
			style="width: 180px; height: auto"
			alt="Focus Cloud"
		/>
	</a>

	<div class="d-flex">
		<span class="p-input-icon-left w-100">
			<i class="pi pi-search"></i>
			<input
				#searchMenuInput
				pInputText
				type="search"
				placeholder="Search..."
				name="searchMenu"
				[(ngModel)]="searchTerm"
				(ngModelChange)="searchClear()"
				class="w-100"
			/>
		</span>
	</div>
	<div *ngIf="searchResult" class="">
		<div class="layout-menu-container">
			<ul class="layout-menu">
				<ng-container *ngFor="let item of searchResult; let i = index">
					<li
						app-menuitem
						[item]="item"
						[index]="i"
						[root]="false"
						[userRole]="user.role"
						[itemRole]="item.roleLevel"
						[faIconPrefix]="item.faIconPrefix"
						[faIcon]="item.faIcon"
						[searchResult]="true"
					></li>
					<li *ngIf="item.separator" class="menu-separator"></li>
				</ng-container>
				<li class="menu-separator"></li>
			</ul>
		</div>
	</div>

	<div class="layout-menu-container">
		<ul class="layout-menu">
			<ng-container *ngFor="let item of userModel; let i = index">
				<li
					*ngIf="!item.hide"
					app-menuitem
					[item]="item"
					[index]="i"
					[root]="true"
					[userRole]="user.role"
					[itemRole]="item.roleLevel"
					[faIconPrefix]="item.faIconPrefix"
					[faIcon]="item.faIcon"
				></li>
				<li *ngIf="item.separator" class="menu-separator"></li>
			</ng-container>
		</ul>
	</div>
</div>
